<template>
    <div>
        <div class="body-overlay" id="body-overlay"></div>
        <SearchPopup />
        <SidebarMenu />
        <Header />
        <Banner />
        <Intro />
        <About />
        <Planning />
        <Team />
        <Client />
        <Instagram />
        <Footer />
    </div>
</template>

<script>
    import SearchPopup from '@/components/layout/SearchPopup.vue'
    import Header from '@/components/layout/Header.vue'
    import Banner from '@/components/page/home/Banner.vue'
    import Intro from '@/components/page/home/Intro.vue'
    import About from '@/components/page/home/About.vue'
    import Planning from '@/components/page/home/Planning.vue'
    import Client from '@/components/page/home/Client.vue'
    import Instagram from '@/components/page/home/Instagram.vue'
    import Footer from '@/components/layout/Footer.vue'

    export default {
        name: "Home",
        components: {
            SearchPopup,
            Header,
            Banner,
            Intro,
            About,
            Planning,
            Client,
            Instagram,
            Footer
        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue